import { HttpClient } from '@angular/common/http'
import { HeaderService } from '../services/header.service'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { serverAddresses } from './server.provider'
import { UnifiedSearchResult } from 'src/app/models/unifiedSearch.model'

@Injectable({
    providedIn: 'root',
})
export class UnifiedSearchProvider {
    server = serverAddresses.api

    constructor(
        private httpClient: HttpClient,
        private headerService: HeaderService,
    ) { }

    makeGlobalSearch(searchTerm: string, showInactive: boolean): Observable<UnifiedSearchResult[]> {
        const url =
            this.server +
            '/unifiedSearch?searchTerm=' +
            encodeURIComponent(searchTerm) +
            '&showInactive=' +
            showInactive
        return this.httpClient.get<UnifiedSearchResult[]>(url, {
            headers: this.headerService.getCommonHeaders(),
        })
    }
}
